// Acceso al módulo Recargas Externas en el FRONT (espejo del backend).
//
// 1. Marca (FAIL-CLOSED): el mismo dist sirve a todas las marcas, así que se decide por
//    el host en tiempo de ejecución. VITE_RECARGAS_TERCEROS_MARCAS (slugs separados por
//    coma) dice dónde está encendido; sin definir = "infynit", porque todas las cuentas
//    MTC son de Infynit. Definida pero vacía = ninguna marca. OJO: se hornea en el build
//    (el backend lee RECARGAS_EXTERNAS_MARCAS en vivo) — cambiar una exige cambiar la otra
//    y recompilar el dist, o el menú y el API dejan de coincidir.
// 2. Si VITE_RECARGAS_TERCEROS_ALLOWLIST está definida (emails separados por coma),
//    SOLO esos usuarios ven el menú/ruta (rollout controlado / canary); vacía =
//    gating normal por tipo (B/C/R).
// 3. Permiso por usuario (migración 068): "vender recargas" o "pagar servicios", que le
//    concede su distribuidor desde el detalle del usuario. Sin ninguno, no hay menú.
// El backend ENFORZA igual — esto solo oculta la UI para que un usuario no-permitido
// no vea la opción.

import { getBrandFromHostname } from "@/config/brands"

function lista(raw: string | undefined): string[] {
  return (raw ?? "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)
}

/** ¿El módulo existe en la marca de este host? (independiente del usuario) */
export function moduloRecargasEnMarca(): boolean {
  const marcas = lista(
    (import.meta.env.VITE_RECARGAS_TERCEROS_MARCAS as string | undefined) ?? "infynit",
  )
  return marcas.includes(getBrandFromHostname())
}

export function puedeRecargasTerceros(
  user: {
    email?: string | null
    tipo_usuario?: string | null
    venta_recargas_habilitada?: boolean
    pago_servicios_habilitado?: boolean
  } | null | undefined,
): boolean {
  if (!moduloRecargasEnMarca() || !user) return false

  const allow = lista(import.meta.env.VITE_RECARGAS_TERCEROS_ALLOWLIST as string | undefined)
  const pasaRollout = allow.length > 0
    ? !!user.email && allow.includes(String(user.email).toLowerCase())
    : !!user.tipo_usuario && ["B", "C", "R"].includes(String(user.tipo_usuario))
  if (!pasaRollout) return false

  return !!(user.venta_recargas_habilitada || user.pago_servicios_habilitado)
}

/** ¿Este usuario reparte los permisos de recargas y servicios? Admin, A y B.
 *  El Master (M) NUNCA entra en este esquema (decisión 2026-09-15): ni concede ni vende. */
export function puedeConcederRecargasTerceros(tipoUsuario: string | null | undefined): boolean {
  return ["Admin", "A", "B"].includes(String(tipoUsuario ?? ""))
}
